<template>
  <section class="content">
    <div class="row center-block">
      <!--      <h2>Data tables</h2>-->
      <div class="col-md-12 row-rm-padding">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title pull-right">
              <button type="button" @click="addPopUp = true" class="btn primary-btn-my clear-new-modal">Add</button>
            </h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6">
                  <div id="example1_length" class="dataTables_length">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table aria-describedby="example1_info" role="grid" id="tableData"
                         class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th aria-label="Rendering engine: activate to sort column descending" aria-sort="ascending"
                          style="width:10%" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"
                          class="sorting_asc">Date
                      </th>
                      <th aria-label="Browser: activate to sort column ascending" style="width:20%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Name
                      </th>
                      <th aria-label="Platform(s): activate to sort column ascending" style="width:10%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Category
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width:32%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Description

                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width:10%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">RCP Products
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width:5%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">State
                      </th>
                      <th style="width:13%" colspan="1" rowspan="1" tabindex="0">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <!-- ======== Add new Document Popup =======  -->
     <md-dialog :md-active.sync="addPopUp" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Add New Document
        <a style="float: right;cursor: pointer;" class="md-primary" @click="addPopUp = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('name')">
                <label class="lable-fileds">Name</label>
                <md-input maxlength="100" id="name" name="name" v-model="form.name"/>
                <span class="md-error" v-if="!$v.form.name.required">The Name is required</span>
                <span class="md-error" v-if="$v.form.name.required && this.newFormBackendValidation.name.isError">{{this.newFormBackendValidation.name.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('description')">
                <label class="lable-fileds">Description</label>
                <md-input maxlength="500"  id="description" name="description" v-model="form.description"/>
                <span class="md-error" v-if="!$v.form.description.required">The description is required</span>
                <span class="md-error" v-if="$v.form.description.required && this.newFormBackendValidation.description.isError">{{this.newFormBackendValidation.description.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('category_id')" class="category_id">
                <label class="lable-fileds">Category</label>
                <md-select v-model="form.category_id" name="category_id" id="category_id">
                  <md-option v-for="item in categoriesSelection" v-bind:key="item.id" :value="item.id">
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.form.category_id.required">The category is required</span>
                <span class="md-error" v-if="$v.form.category_id.required && this.newFormBackendValidation.category_id.isError">{{this.newFormBackendValidation.category_id.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('products')" class="products">
                <label class="lable-fileds">Products</label>
                <md-select name="products" id="products" multiple v-model="form.products">
                  <md-option v-for="item in productsSelection" v-bind:key="item.id" :value="item.id">
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.form.products.required">The product is required</span>
                <span class="md-error" v-if="$v.form.products.required && this.newFormBackendValidation.products.isError">{{this.newFormBackendValidation.products.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('industries')">
                <label v-if="IndustrySelected.length != 0" class="multiLable">Industries</label>
                <multiselect v-model="IndustrySelected" tag-placeholder="Add industries as new tag" placeholder="Search or add an industries" label="name" track-by="id" :options="IndustriesList" :multiple="true" :taggable="true"></multiselect>
                <span class="md-error" v-if="!$v.form.industries.required">The Industries is required</span>
                <span class="md-error" v-if="$v.form.industries.required && this.editFormBackendValidation.industries.isError">{{this.editFormBackendValidation.industries.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('device_type')" class="device_type">
                <label class="lable-fileds">Allowed Device Type</label>
                <md-select v-model="form.device_type" name="device_type" id="device_type" md-dense>
                  <md-option value="b">Mobile and Web</md-option>
                  <md-option value="m">Only Mobile</md-option>
                  <md-option value="w">Only Web</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.form.device_type.required">The Allowed Device Type is required</span>
                <span class="md-error" v-if="$v.form.device_type.required && this.newFormBackendValidation.device_type.isError">{{this.newFormBackendValidation.device_type.errorMsg}}</span>
              </md-field>

              <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :awss3="awss3" :options="dropzoneOptions"></vue-dropzone> -->
              <div :class="getValidationClass('n_fileNewFrm')" class="box-upload" v-if="isUploadImage">
                <div class="box-upload-icon">
                  <i class="fa fa-upload" aria-hidden="true">
                    <input class="box-upload-file" @change="previewFiles($event.target.files,true)" id="n_fileNewFrm" name="n_fileNewFrm" ref="myFiles" type="file"/>
                  </i>
                  <span>Upload PDF</span>
                </div>
              </div>
              <div class="box-upload" v-if="isUploadingImage">
                <sync-loader :loading="isUploadingImage" :color="editModalColor" :size="editModalSize"
                              :width="editModalWidth" :margin="editModalMargin"></sync-loader>
              </div>
              <div class="box-upload" v-if="isUploadedImage">
                <div class="box-upload-icon">
                  <i class="fa fa-check-square" aria-hidden="true">
                    <input class="box-upload-file" @change="previewFiles($event.target.files,true)" id="fileNewFrm" name="fileNewFrm" ref="myFiles" type="file"/>
                  </i>
                  <span style="border-bottom: 10px">Completed</span>
                </div>
              </div>
              <div class="box-upload" v-if="isUploadErrorImage">
                <div class="box-upload-icon">
                  <i class="fa fa-upload" aria-hidden="true">
                    <input class="box-upload-file" @change="previewFiles($event.target.files,true)" id="fileNewFrm" name="fileNewFrm" ref="myFiles" type="file"/>
                  </i>
                  <span>PDF upload failed. Please retry.</span>
                </div>
              </div>
            </div>
          </div>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="validateNewDocumentSubmission" class="btn primary-btn-my custom-modal-footer-items">Add Document</button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="newModalLoading" :color="newModalColor" :size="newModalSize"
                         :width="newModalWidth" :margin="newModalMargin"></sync-loader>
          </div>

        </form>
    </md-dialog>

    <!-- ================== Edit Documents model ================== -->
    <md-dialog :md-active.sync="editModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Edit Document
        <a style="float: right;cursor: pointer;" class="md-primary" @click="editModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('name')">
                <label class="lable-fileds">Name</label>
                <md-input maxlength="100" v-model="editForm.name" id="name" name="name"/>
                <span class="md-error" v-if="!$v.editForm.name.required">The Name is required</span>
                <span class="md-error" v-if="$v.editForm.name.required && this.editFormBackendValidation.name.isError">{{this.editFormBackendValidation.name.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('description')">
                <label class="lable-fileds">Description</label>
                <md-input maxlength="500" v-model="editForm.description" id="description" name="description"/>
                <span class="md-error" v-if="!$v.editForm.description.required">The description is required</span>
                <span class="md-error" v-if="$v.editForm.description.required && this.editFormBackendValidation.description.isError">{{this.editFormBackendValidation.description.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('category_id')" class="category_id">
                <label class="lable-fileds">Category</label>
                <md-select v-model="editForm.category_id" name="category" id="category">
                  <md-option v-for="item in categoriesSelection" v-bind:key="item.id" :value="item.id">
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.editForm.category_id.required">The category is required</span>
                <span class="md-error" v-if="$v.editForm.category_id.required && this.editFormBackendValidation.category_id.isError">{{this.editFormBackendValidation.category_id.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('products')" class="products">
                <label class="lable-fileds">Products</label>
                <md-select name="products" id="products" multiple v-model="editForm.products">
                  <md-option v-for="item in productsSelection" v-bind:key="item.id" :value="item.id">
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.editForm.products.required">The product is required</span>
                <span class="md-error" v-if="$v.editForm.products.required && this.editFormBackendValidation.products.isError">{{this.editFormBackendValidation.products.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('industries')">
                <label v-if="IndustrySelected.length != 0" class="multiLable">Industries</label>
                <multiselect v-model="IndustrySelected" tag-placeholder="Add industries as new tag" placeholder="Search or add an industries" label="name" track-by="id" :options="IndustriesList" :multiple="true" :taggable="true"></multiselect>
                <span class="md-error" v-if="!$v.editForm.industries.required">The Industries is required</span>
                <span class="md-error" v-if="$v.editForm.industries.required && this.editFormBackendValidation.industries.isError">{{this.editFormBackendValidation.industries.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClass('device_type')" class="device_type">
                <label class="lable-fileds">Allowed Device Type</label>
                <md-select v-model="editForm.device_type" name="device_type" id="device_type" md-dense>
                  <md-option value="b">Mobile and Web</md-option>
                  <md-option value="m">Only Mobile</md-option>
                  <md-option value="w">Only Web</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.editForm.device_type.required">The Allowed Device Type is required</span>
                <span class="md-error" v-if="$v.editForm.device_type.required && this.editFormBackendValidation.device_type.isError">{{this.editFormBackendValidation.device_type.errorMsg}}</span>
              </md-field>
              <div class="box-upload" v-if="isUploadImage">
                <div class="box-upload-icon">
                  <i class="fa fa-upload" aria-hidden="true">
                    <input class="box-upload-file" @change="previewFiles($event.target.files,false)" id="file" ref="myFiles" type="file"/>
                  </i>
                  <span>Upload PDF</span>
                </div>
              </div>
              <div class="box-upload" v-if="isUploadingImage">
                <sync-loader :loading="isUploadingImage" :color="editModalColor" :size="editModalSize"
                              :width="editModalWidth" :margin="editModalMargin"></sync-loader>
              </div>
              <div class="box-upload" v-if="isUploadedImage">
                <div class="box-upload-icon">
                  <i class="fa fa-check-square" aria-hidden="true">
                  <input class="box-upload-file" @change="previewFiles($event.target.files,false)" id="file" ref="myFiles" type="file"/>
                  </i>
                  <span>Completed</span>
                  <img v-if="isUploadedImage" :src="awsImageFixedUrl + editForm.thumbnail" alt="icon" class="img-thumbnail">
                </div>
              </div>
              <div class="box-upload" v-if="isUploadErrorImage">
                <div class="box-upload-icon">
                  <i class="fa fa-upload" aria-hidden="true">
                    <input class="box-upload-file" @change="previewFiles($event.target.files,false)" id="file" name="fileNewFrm" ref="myFiles" type="file"/>
                  </i>
                  <span>PDF upload failed. Please retry.</span>
                </div>
              </div>
            </div>
          </div>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="validateEditDocumentSubmission" class="btn primary-btn-my custom-modal-footer-items">
              Update
            </button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="editModalLoading" :color="editModalColor" :size="editModalSize"
                         :width="editModalWidth" :margin="editModalMargin"></sync-loader>
          </div>

        </form>
    </md-dialog>

     <!-- ================== Notifi Modal Video model ================== -->
     <md-dialog :md-active.sync="notifiModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Notification Control
        <a style="float: right;cursor: pointer;" class="md-primary" @click="notifiModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
          <md-field>
            <label class="lable-fileds">Select Filter Type</label>
            <md-select name="product" id="product" v-model="filter.filter_type" @md-selected="loadFilterData(filter.filter_type)">
              <md-option value="industry">Industries</md-option>
              <md-option value="organization">Organizations</md-option>
              <md-option value="state">States</md-option>
              <md-option value="user">Users</md-option>
            </md-select>
          </md-field>
          <md-field>
            <label class="lable-fileds">Select options</label>
            <md-select name="product" id="product" v-model="selectFilter_value" multiple :disabled="isDisabledOption" @md-selected="GetUserCount(selectFilter_value)">
              <md-option value="all">All</md-option>
              <md-option v-for="item in filterType" v-bind:key="item.id" :value="item.id">
                {{item.name}}
              </md-option>
            </md-select>
          </md-field>
          <span>Users Count : {{filterUserCount}}</span>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="triggerNotification" class="btn primary-btn-my custom-modal-footer-items">
              Trigger Notification
            </button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="editModalLoading" :color="editModalColor" :size="editModalSize"
                         :width="editModalWidth" :margin="editModalMargin"></sync-loader>
          </div>

        </form>
    </md-dialog>

  </section>

</template>
<script>
  // import '../../../../static/js/pdf.js'
  // import '../../../../static/js/pdfThumbnails.js'
  import AWS from 'aws-sdk'

  AWS.config.region = 'ap-southeast-1' // 1. Enter your region

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'ap-southeast-1:d3a76794-ef80-4000-a846-afb95dc782f3' // 2. Enter your identity pool
  })

  AWS.config.credentials.get(function(err) {
    if (err) alert(err)
  })

  var bucketName = 'smartapprcp' // Enter your bucket name
  var bucket = new AWS.S3({
    params: {
      Bucket: bucketName
    }
  })
  import api from '../../../api'
  import $ from 'jquery'
  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  var moment = require('moment')

  var SyncLoader = require('vue-spinner/src/SyncLoader')

  // vue validations
  import {validationMixin} from 'vuelidate'
  import {
    required
  } from 'vuelidate/lib/validators'
  import config from '../../../config'
  import Vue from 'vue'

  export default {
    name: 'VideosView',
    mixins: [validationMixin],
    components: {
      'SyncLoader': SyncLoader
    },
    data() {
      return {
        filterUserCount: 0,
        isDisabledOption: true,
        notifiModal: false,
        filterType: [],
        selectFilter_value: [],
        filter: {
          reference_id: '',
          type: 'document',
          filter_type: '',
          filter_value: ''
        },
        userCount: {
          type: 'document',
          filter_type: '',
          filter_value: ''
        },
        dataTable: null,
        isUploadImage: true,
        isUploadingImage: false,
        isUploadedImage: false,
        isUploadErrorImage: false,
        categoriesSelection: [],
        productsSelection: [],
        IndustrySelected: [],
        IndustriesList: [],
        form: {
          name: null,
          description: null,
          category: null,
          product: null,
          url: null,
          device_type: 'b',
          thumbnail: 'rcp_docs/thumbnail/0.4796142476186347.jpg',
          industries: []
        },
        editForm: {
          name: null,
          description: null,
          category: null,
          product: null,
          url: null,
          device_type: null,
          thumbnail: 'rcp_docs/thumbnail/0.4796142476186347.jpg',
          industries: []
        },
        newFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          category_id: {
            isError: false,
            errorMsg: ''
          },
          products: {
            isError: false,
            errorMsg: ''
          },
          device_type: {
            isError: false,
            errorMsg: ''
          },
          description: {
            isError: false,
            errorMsg: ''
          },
          url: {
            isError: false,
            errorMsg: ''
          },
          industries: {
            isError: false,
            errorMsg: ''
          }
        },
        editFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          category_id: {
            isError: false,
            errorMsg: ''
          },
          products: {
            isError: false,
            errorMsg: ''
          },
          device_type: {
            isError: false,
            errorMsg: ''
          },
          description: {
            isError: false,
            errorMsg: ''
          },
          url: {
            isError: false,
            errorMsg: ''
          },
          industries: {
            isError: false,
            errorMsg: ''
          }
        },
        addPopUp: false,
        newModalLoading: false,
        editModal: false,
        editModalLoading: false,
        editModalColor: '#FECD2F',
        editModalSize: '10px',
        editModalHeight: '35px',
        editModalWidth: '5px',
        editModalMargin: '2px',
        editModalRadius: '2px',
        newModalColor: '#FECD2F',
        newModalSize: '10px',
        newModalHeight: '35px',
        newModalWidth: '5px',
        newModalMargin: '2px',
        newModalRadius: '2px',
        awsImageFixedUrl: 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/'
      }
    },
    mounted() {
      // clear new modal
      var ref = this
      $('h3').on('click', 'button.clear-new-modal', function () {
        ref.clearForm()
      })
      this.$nextTick(() => {
        this.setCategoryDropDownData()
        this.setProductDropDownData()
        this.initDatatable()
        this.initJqueryMethods()
        this.getIndustriesList()
      })
    },
    validations: {
      form: {
        name: {
          required
        },
        description: {
          required
        },
        category_id: {
          required
        },
        products: {
          required
        },
        url: {
          required
        },
        device_type: {
          required
        },
        industries: {
          required
        }
      },
      editForm: {
        name: {
          required
        },
        description: {
          required
        },
        category_id: {
          required
        },
        products: {
          required
        },
        url: {
          required
        },
        device_type: {
          required
        },
        industries: {
          required
        }
      }
    },
    methods: {
      GetUserCount(selectData) {
        if (this.filter.filter_type === null || this.filter.filter_type === '' || this.selectFilter_value.length <= 0) {
          console.log('ok')
        } else {
          var ref = this
          var b = false
          for (let x = 0; x < ref.selectFilter_value.length; x++) {
            if (ref.selectFilter_value[x] === 'all') {
              b = true
            }
          }
          if (b) {
            this.userCount.filter_value = 'all'
          } else {
            this.userCount.filter_value = this.selectFilter_value
          }
          api.request('post', '/count_user/send-notification', this.userCount)
            .then(response => {
              if (response.status === 200) {
                if (response.data.result.status !== 'error') {
                  ref.filterUserCount = response.data.result
                } else {
                  ref.filterUserCount = 0
                }
              } else {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: 'Something wrong'})
              }
            }).catch(error => {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: error})
            })
        }
      },
      triggerNotification() {
        // alert(this.selectFilter_value.length)
        if (this.filter.filter_type === null || this.filter.filter_type === '' || this.selectFilter_value.length <= 0) {
          // eslint-disable-next-line no-undef
          toast.fire({icon: 'error', title: 'Select filter type'})
        } else {
          var ref = this
          var b = false
          for (let x = 0; x < ref.selectFilter_value.length; x++) {
            if (ref.selectFilter_value[x] === 'all') {
              ref.selectFilter_value = []
              ref.selectFilter_value.push('all')
              b = true
            }
          }
          if (b) {
            this.filter.filter_value = 'all'
          } else {
            this.filter.filter_value = this.selectFilter_value
          }
          api.request('post', '/send-notification', this.filter)
            .then(response => {
              if (response.status === 200) {
                this.notifiModal = false
                this.filter.reference_id = ''
                this.filter.filter_type = ''
                this.filter.filter_value = ''
                this.selectFilter_value = []
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: 'Something wrong'})
              }
            }).catch(error => {
            // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: error})
            })
        }
      },
      loadFilterData(type) {
        this.isDisabledOption = false
        this.userCount.filter_type = type
        api.request('get', '/send-notification/documents')
          .then(response => {
            if (response.status === 200) {
              if (type === 'industry') {
                this.filterType = response.data.result.industries
              } else if (type === 'organization') {
                this.filterType = response.data.result.organizations
              } else if (type === 'state') {
                this.filterType = response.data.result.states
              } else if (type === 'user') {
                this.filterType = response.data.result.users
              }
              this.selectFilter_value = []
              this.filterUserCount = 0
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      notificationTrigger(id) {
        this.filter.reference_id = id
        this.notifiModal = true
      },
      getIndustriesList() {
        api
          .request('get', '/admin/industries/select')
          .then(response => {
            this.IndustriesList = response.data.result
          })
      },
      previewFiles(files, isNew) {
        var txt = "Existing pdf will be removed,You won't be able to revert this!"
        var confirmButtonText = 'Yes, replace new pdf'
        if (isNew) {
          txt = 'You want to upload a pdf!'
          confirmButtonText = 'Yes, upload new pdf'
        }
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: txt,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: confirmButtonText
        }).then((result) => {
          if (result.value) {
            this.isUploadingImage = true
            this.isUploadImage = false
            this.isUploadedImage = false
            this.isUploadErrorImage = false
            var ref = this
            let file = files[0]
            var randomMathName = Math.random()
            var randomName = 'rcp_docs/' + randomMathName + '.pdf'
            var thumbnail = 'rcp_docs/thumbnail/' + randomMathName + '.jpg'
            var params = {
              Key: randomName,
              ContentType: file.type,
              Body: file,
              ACL: 'public-read'
            }
            bucket.putObject(params, function (err, data) {
              if (err) {
                ref.isUploadingImage = false
                ref.isUploadImage = false
                ref.isUploadedImage = false
                ref.isUploadErrorImage = true
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: err})
              } else {
                ref.isUploadingImage = false
                ref.isUploadImage = false
                ref.isUploadedImage = true
                this.isUploadErrorImage = false
                if (isNew) {
                  ref.form.url = randomName
                  ref.form.thumbnail = thumbnail
                } else {
                  ref.editForm.url = randomName
                  ref.editForm.thumbnail = thumbnail
                }
              }
            })
          }
        })
      },
      initJqueryMethods() {
        var ref = this
        // edit modal open
        $('#tableData tbody').on('click', 'td.details-control button.btn-modal-edit', function () {
          var id = $(this).attr('data-id')
          ref.showEditModal(id)
        })
        // delete record
        $('#tableData tbody').on('click', 'td.details-control button.btn-delete', function () {
          var id = $(this).attr('data-id')
          ref.deleteRecord(id)
        })
         // notifi record
        $('#tableData tbody').on('click', 'td.details-control button.btn-notifi', function () {
          var id = $(this).attr('data-id')
          ref.notificationTrigger(id)
        })
      },
      showEditModal(id) {
        this.IndustrySelected = []
        this.isUploadingImage = false
        this.isUploadImage = true
        this.isUploadedImage = false
        this.isUploadErrorImage = false
        api.request('get', '/admin/documents/show/' + id)
          .then(response => {
            if (response.status === 200) {
              this.editForm = response.data.result
              for (let x = 0; x < this.editForm.industries.length; x++) {
                for (let y = 0; y < this.IndustriesList.length; y++) {
                  if (this.editForm.industries[x] === this.IndustriesList[y].id) {
                    this.IndustrySelected.push(this.IndustriesList[y])
                  }
                }
              }
              this.editModal = true
              if (this.editForm.url === null || this.editForm.url === '') {
                this.isUploadingImage = false
                this.isUploadImage = false
                this.isUploadedImage = false
                this.isUploadErrorImage = true
              } else {
                this.isUploadingImage = false
                this.isUploadImage = false
                this.isUploadedImage = true
                this.isUploadErrorImage = false
              }
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      setProductDropDownData() {
        api
          .request('get', '/admin/products/select')
          .then(response => {
            this.productsSelection = response.data.result
          })
      },
      setCategoryDropDownData() {
        api
          .request('get', '/admin/categories/select')
          .then(response => {
            this.categoriesSelection = response.data.result
          })
      },
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm() {
        this.$v.$reset()
        this.form.name = ''
        this.form.description = ''
        this.form.category = ''
        this.form.product = ''
        this.form.url = ''
        this.device_type = 'b'
        this.isUploadImage = true
        this.isUploadingImage = false
        this.isUploadedImage = false
        this.isUploadErrorImage = false
        this.IndustrySelected = ''
      },
      initDatatable() {
        this.dataTable = $('#tableData')
          .on('xhr.dt', function (e, settings, json, xhr) {
            json.recordsTotal = json.result.original.recordsTotal
            json.draw = json.result.original.draw
            json.recordsFiltered = json.result.original.recordsFiltered
          })
          .DataTable({
            serverSide: true,
            processing: true,
            responsive: true,
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            search: {
              'caseInsensitive': false
            },

            order: [[0, 'desc']],
            ajax: {
              url: config.serverURI + '/admin/documents/datatable',
              type: 'get',
              contentType: 'application/json; charset=UTF-8',
              dataSrc: 'result.original.data',
              headers: {Authorization: 'Bearer ' + Vue.auth.getToken()}
            },
            columnDefs: [
              {
                'orderable': true,
                'targets': [0],
                'responsivePriority': 0,
                'searchable': false,
                'render': function (data, type, full, meta) {
                  return '<span>' + moment(full.updated_at).format('MM/DD/YYYY') + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [1],
                'responsivePriority': 1,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [2],
                'responsivePriority': 2,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.category.name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [3],
                'responsivePriority': 3,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.description + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [4],
                'responsivePriority': 4,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  console.log(full.products)
                  for (var product of full.products) {
                    return '<span>' + product.name + '</span>'
                  }
                  return '<span>N/A</span>'
                }
              },
              {
                'orderable': true,
                'targets': [5],
                'responsivePriority': 5,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  if (full.status === '1') {
                    return '<span class="badge bg-green">Active</span>'
                  } else if (full.status === 0) {
                    return '<span class="badge bg-primary">Deactive</span>'
                  }
                  return '<span class="badge badge-warning">N/A</span>'
                }
              },
              {
                'orderable': false,
                'targets': [6],
                'responsivePriority': 6,
                'searchable': false,
                'className': 'details-control',
                'render': function (data, type, full, meta) {
                  return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-pencil" aria-hidden="true"></i>' +
                    '</button>&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>' +
                    '&nbsp;<ejs-tooltip ref="tooltip" content="Tooltip content" ><button data-id= ' + full.id + ' type="button" class="btn btn-notifi btn-sm btn-notifi"><i class="fa fa-bell" aria-hidden="true"></i></button></ejs-tooltip>'
                }
              }
            ]
          })
      },
      validateNewDocumentSubmission() {
        if (this.IndustrySelected.length > 0) {
          this.form.industries = []
          for (let x = 0; x < this.IndustrySelected.length; x++) {
            this.form.industries.push(this.IndustrySelected[x].id)
          }
        }
        this.$v.form.$touch()

        if (!this.$v.form.$invalid) {
          this.addNewRecord(this.$v.form.$model)
        }
      },
      validateEditDocumentSubmission() {
        if (this.IndustrySelected.length > 0) {
          this.editForm.industries = []
          for (let x = 0; x < this.IndustrySelected.length; x++) {
            this.editForm.industries.push(this.IndustrySelected[x].id)
          }
        }
        this.$v.editForm.$touch()

        if (!this.$v.editForm.$invalid) {
          this.updateRecord(this.$v.editForm.$model)
        }
      },
      addNewRecord(data) {
        this.newModalLoading = true
        data.status = 1
        var ref = this
        api.request('post', '/admin/documents/create', data)
          .then(response => {
            if (response.status === 200) {
              this.newModalLoading = false
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.newFormBackendValidation.hasOwnProperty(key.toString())) {
                    ref.newFormBackendValidation[key.toString()].isError = true
                    ref.newFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                    $('.' + key.toString()).addClass('md-invalid')
                    if (key.toString() === 'url') {
                      ref.isUploadingImage = false
                      ref.isUploadImage = false
                      ref.isUploadedImage = false
                      ref.isUploadErrorImage = true
                    }
                  }
                })
              } else if (response.data.result.status === 'success') {
                ref.addPopUp = false
                ref.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else if (response.data.result.status === 'error') {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              ref.newModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
            // if (response.status === 200) {
            //   this.newModalLoading = false
            //   // this.form = response.data.result
            //   this.addPopUp = false
            //   this.dataTable.ajax.reload(null, false)
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'success', title: 'Record successfully saved'})
            // } else {
            //   this.newModalLoading = false
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'error', title: 'Something wrong'})
            // }
          }).catch(error => {
            ref.newModalLoading = false
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            ref.response = 'Server appears to be offline'
            ref.toggleLoading()
          })
      },
      deleteRecord(id) {
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            api.request('get', '/admin/documents/delete/' + id)
              .then(response => {
                if (response.status === 200 || response.status.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Record successfully deleted'})
                  this.dataTable.ajax.reload(null, false)
                }
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
          }
        })
      },
      updateRecord(data) {
        this.editModalLoading = true
        var ref = this
        api.request('post', '/admin/documents/update/' + data.id, data)
          .then(response => {
            if (response.status === 200) {
              this.editModalLoading = false
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.editFormBackendValidation.hasOwnProperty(key.toString())) {
                    ref.editFormBackendValidation[key.toString()].isError = true
                    ref.editFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                    $('.' + key.toString()).addClass('md-invalid')
                    if (key.toString() === 'url') {
                      ref.isUploadingImage = false
                      ref.isUploadImage = false
                      ref.isUploadedImage = false
                      ref.isUploadErrorImage = true
                    }
                  }
                })
              } else if (response.data.result.status === 'success') {
                ref.editModal = false
                ref.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else if (response.data.result.status === 'error') {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              ref.editModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
            // if (response.status === 200 || response.status.status === 'success') {
            //   this.form = response.data.result
            //   this.editModalLoading = false
            //   this.editModal = false
            //   this.dataTable.ajax.reload(null, false)
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'success', title: 'Record updated successfully'})
            // } else {
            //   this.editModalLoading = false
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'error', title: 'Something wrong'})
            // }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            this.editModalLoading = false
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      }
    }
  }
</script>

<style>

  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'FontAwesome';
  }

  table.dataTable thead .sorting:after {
    content: '\f0dc';
  }

  table.dataTable thead .sorting_asc:after {
    content: '\f0dd';
  }

  table.dataTable thead .sorting_desc:after {
    content: '\f0de';
  }


</style>



// WEBPACK FOOTER //
// DocumentsView.vue?1372410a